import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'

import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { useParams } from 'react-router-dom'
import { HistoricoValorProfissionalList, ValorProfissionalList } from './_models'
import { getHistoricoValoresProfissional, getValoresProfissional } from './_requests'

const QueryResponseContext = createResponseContext<
  HistoricoValorProfissionalList | ValorProfissionalList
>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { id } = useParams<{ id: string }>()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const queryFn =
    state.tab === 'historico'
      ? () => getHistoricoValoresProfissional(query, Number(id))
      : () => getValoresProfissional(query, Number(id))

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.PROFISSIONAL_VALORES_LIST, id, query, isOpen, state.tab], queryFn, {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
